@if (heading) {
  <div class="model-attribute-grid__header">
    <h5 [innerHTML]="heading" [style.textAlign]="alignItems"></h5>
  </div>
}
<div
  class="model-attribute-grid__container"
  [style.textAlign]="alignItems"
  [style.flexDirection]="alignItems === 'right' ? 'row-reverse' : 'row'"
>
  @for (ModelAttributeConfig of configs; track ModelAttributeConfig) {
    <div
      [style.width.%]="
        isHorizontal ? 100 / configs.length : 100 / (columns || configs.length)
      "
    >
      <model-attribute
        [direction]="direction"
        [context]="context"
        [config]="ModelAttributeConfig"
      >
      </model-attribute>
    </div>
  }
</div>
